module.exports = __webpack_public_path__ + "static/media/logo-light.29d37e7e.png";